import Wrapper from "../../layout/wrapper/Wrapper";
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Grid,
  InputAdornment,
  List,
  ListItem,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Snackbar,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import * as yup from "yup";
import styles from "../../styles/pages/partnereditor.module.scss";
import styles1 from "../../styles/pages/partners.module.scss";
import React, { useCallback, useState } from "react";
import NotificationLeftFilter from "../../components/NotificationLeftFilter/NotificationLeftFilter";
import AddRadiusIcon from "../../ui/Icons/AddRadiusIcon";
import VideosummaryCard from "../../components/VideosummaryCard/VideosummaryCard";
import PartnerCard from "../../components/PartnerCard/PartnerCard";
import assest from "../../json/assest";
import AddNewEditorModal from "../../ui/Modal/AddNewEditorModal";
import TabPanel from "../../components/UtilitiesComponent/TabPanel";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import NextArrow from "../../ui/Icons/NextArrow";
import StatusSearch from "../../components/StatusSearch/StatusSearch";
import useFetch, { usePost } from "../../hooks/api/useFetch";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import useNotiStack from "../../hooks/useNotistack";
import axiosInstance from "../../api/axiosInstance";
import { countryData } from "../../lib/functions/utils.lib";
import ApiLoader from "../../components/Loaders/ApiLoader";
import { useInfiniteFetch } from "../../hooks/api/useInfiniteFetch";
import { Fragment } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

const schema = yup.object({
  account_name: yup
    .string()
    .min(2, "Account name must be at-least 2 characters long"),
  first_name: yup
    .string()
    .required("First name is required")
    .min(2, "First name must be at-least 2 characters long"),
  last_name: yup
    .string()
    .required("Last name is required")
    .min(2, "Last name must be at-least 2 characters long"),
  address: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  zip_code: yup.string().max(7).required("Zip code is required"),
  state: yup.string().required("State is required"),
  mobile: yup
    .string()
    .required("Phone number is required")
    .matches(
      /^(\+\d{1,2}\s)?\(?\d{1,15}\)?[\s.-]?\d{1,15}[\s.-]?\d{1,15}$/,
      "Phone number is not valid"
    ),
  email: yup.string().email("Email is not valid"),
});

const Partner = () => {
  const [openNewEditorModal, setOpenNewEditorModal] = useState(false);

  const handleOpenNewEditorModal = useCallback(() => {
    setOpenNewEditorModal(true);
  }, []);

  const handleCloseNewEditorModal = useCallback(() => {
    setOpenNewEditorModal(false);
  }, []);

  /****************************/

  const [status, setStatus] = useState("");
  const [search, setSearch] = useState("");
  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
    type: "",
  });

  const getDataFromChild = (date) => {
    setStatus("");
    setDate(date);
  };
  const statusFn = (data) => {
    setDate({ startDate: "", endDate: "", type: "" });
    setSearch("");
    setStatus(data);
  };
  const searchFn = (data) => {
    setStatus("");
    setSearch(data);
  };

  const handleChange1 = (event) => {
    setStatus(event.target.value);
  };

  /************************/

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  /*****************************/
  const [age, setAge] = useState("");

  const handleChange2 = (event) => {
    setAge(event.target.value);
  };

  const [snackOpen, setSnackOpen] = useState(false);

  const handleClick = () => {
    setValue(1);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
    setOpenNewEditorModal(false);
  };
  const [compensationType, setCompensationType] = useState("");
  const handleCompensationType = (comp = "") => {
    setCompensationType((prev) => {
      if (prev === comp) return "";
      return comp;
    });
  };
  const [salaryData, setSalaryData] = useState({
    flat_rate: "",
    rate_per_video: "",
  });
  const { toastSuccess, toastError } = useNotiStack();

  const handleFormData = (event) => {
    const { name, value } = event.target;

    setSalaryData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const [Country, setCountry] = useState("");
  const handleCountryChange = (event) => {
    setCountry(event.target.value);
  };
  const [profile, setProfile] = React.useState(null);
  const uploadImage = (e) => {
    console.warn(e.target, "image");
    if (
      e.target.files[0]?.type === "image/jpeg" ||
      e.target.files[0]?.type === "image/png" ||
      e.target.files[0]?.type === "image/jpg"
    ) {
      if (e.target.files[0]?.size <= 3000000) {
        setProfile(e.target.files[0]);
        e.target.value = null;
      } else {
        toastError("Please upload image of proper size.");
      }
    } else {
      toastError("Please upload image of proper format.");
    }
  };
  console.warn(profile);

  const handleAddNewMemberForm = async (data) => {
    let formData = new FormData();
    formData.append("account_name", data.account_name);
    formData.append("name", data.first_name);
    formData.append("last_name", data.last_name);
    formData.append("role_id", 3);
    formData.append("address", data.address);
    formData.append("city", data.city);
    formData.append("state", data.state);
    formData.append("zip", data.zip_code);
    formData.append("phone", data.mobile);
    formData.append("email", data.email);
    formData.append("country", Country);
    formData.append("flat_rate", salaryData?.flat_rate);
    formData.append("revenue_share", data.revenue_share);
    formData.append("rate_per_video", salaryData?.rate_per_video);
    formData.append(
      "payment_type",
      compensationType === "rate_per_video" ? 2 : 1
    );
    formData.append("submission_link", data.submission_link);
    {
      profile == null ? "" : formData.append("avatar", profile);
    }

    await axiosInstance
      .post("admin/createuser", formData)
      .then((res) => {
        if (res?.data?.message === "User added successfully") {
          setOpenNewEditorModal(false);
          setSnackOpen(true);
          refetchPartnersList();
        }
      })
      .catch((err) => {
        if (err?.data?.message) {
          toastSuccess(err?.data?.message);
        }
      });
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const {
    data: partnersList,
    isError,
    isLoading,
    isFetching,
    isSuccess,
    hasNextPage,
    fetchNextPage,
    refetch: refetchPartnersList,
  } = useInfiniteFetch(
    ["partners", date?.startDate, date?.endDate, status, search],
    `admin/users/3?created_at_from=${date?.startDate}&created_at_to=${
      date?.endDate
    }${status.toString() ? "&status=" + status : ""}
        ${search ? "&search=" + search : ""}`
  );

  const {
    data: usersSummary,
    isError: usersSummaryIsError,
    isLoading: usersSummaryIsLoading,
    isSuccess: usersSummaryIsSuccess,
  } = usePost(
    ["users-summary", date.startDate, date.endDate],
    "admin/users-summary/3",
    { from: date?.startDate, to: date?.endDate }
  );

  return (
    <Wrapper>
      {/* <Seo title="Partners" canonical={''} description={''} url={''} image={''} /> */}
      <ApiLoader
        loading={
          (isLoading || isFetching) &&
          !(
            isSuccess ||
            partnersList?.pages?.length ||
            search.length ||
            status.toString() ||
            date.startDate.length ||
            date.endDate.length
          )
        }
      />
      <Box className="main_body">
        <Box className={styles.partnerListScrollBar}>
          <PerfectScrollbar>
            {(isLoading || isFetching) &&
            !(
              isSuccess ||
              partnersList?.pages?.length ||
              search.length ||
              status.toString() ||
              date.startDate.length ||
              date.endDate.length
            ) ? (
              ""
            ) : isSuccess ||
              partnersList?.data.data.length ||
              search.length ||
              status.toString() ||
              date.startDate.length ||
              date.endDate.length ? (
              <Box className={`${styles.editorBody} ${styles.bodyScroll}`}>
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  className={styles.bttmGap}
                >
                  <Box
                    className={`${styles.SecFilter} ${styles.editorSecFilter}`}
                  >
                    <NotificationLeftFilter
                      filterType={"for_partners"}
                      getDataFromChild={getDataFromChild}
                    />
                  </Box>

                  <Box className={styles.searchStatus}>
                    <Box
                      className={`${styles.innerSearch} ${styles1.innerSearchPartners}`}
                    >
                      <StatusSearch
                        getStatusData={statusFn}
                        getSearchData={searchFn}
                        goToChild={status}
                      />
                      <InfiniteScroll
                        dataLength={
                          partnersList?.data?.data?.length
                            ? partnersList?.data?.data?.length
                            : 0
                        }
                        next={fetchNextPage}
                        height={`calc(100vh - 189px)`}
                        hasMore={hasNextPage}
                        loader={<h4>Loading... </h4>}
                        className={styles.infiniteScrollPartner}
                      >
                        {partnersList?.pages?.length
                          ? partnersList?.pages.map((group, index) => (
                              <Fragment key={index}>
                                {group?.data?.data.map((item, index) => {
                                  return (
                                    <PartnerCard
                                      refetchPartnersList={refetchPartnersList}
                                      key={index}
                                      user={item}
                                      image={item?.avatar}
                                      cardName={item?.account_name}
                                      cardLink={item?.submission_link}
                                      cardTime={item?.created_at}
                                      cardTextspan1={"Fee Per Submission:"}
                                      cardTextspan2={"Full Name:"}
                                      cardTextspan3={"email address:"}
                                      cardtext1={
                                        item?.flat_rate ? item?.flat_rate : "0"
                                      }
                                      cardtext2={`${item?.name} ${item?.last_name}`}
                                      cardtext3={item?.email}
                                      buttonName={
                                        `${item?.status}` == 1
                                          ? "ACTIVE"
                                          : "INACTIVE"
                                      }
                                      accountSubmission={true}
                                      classProps={"true"}
                                      cardProp={"partner"}
                                      user_id={item?.id}
                                      cardVideoCount={
                                        item?.videos_count
                                          ? item?.videos_count
                                          : "-"
                                      }
                                      cardVideoApprovedCount={
                                        item?.videosApproved
                                          ? item?.videosApproved
                                          : "-"
                                      }
                                      cardVideoRejectedCount={
                                        item?.videosRejected
                                          ? item?.videosRejected
                                          : "-"
                                      }
                                      cardVideoDuplicateCount={
                                        item?.videos_duplicate
                                          ? item?.videos_duplicate
                                          : "-"
                                      }
                                    />
                                  );
                                })}
                              </Fragment>
                            ))
                          : ""}
                      </InfiniteScroll>
                    </Box>
                  </Box>

                  <Box className={styles.addEditor}>
                    <Button
                      startIcon={<AddRadiusIcon />}
                      className={styles.addeditorBtn}
                      onClick={() => handleOpenNewEditorModal()}
                    >
                      Add new Partner
                    </Button>
                    <VideosummaryCard
                      videoTitle={"Submissions Summary"}
                      countVideo={""}
                    >
                      <List>
                        <ListItem>
                          <Typography variant="body1">
                            All submissions
                          </Typography>

                          <Typography variant="caption">
                            {usersSummary?.data?.all_submissions
                              ? usersSummary?.data?.all_submissions
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Approved submissions
                          </Typography>
                          <Typography variant="caption">
                            {usersSummary?.data?.approved_videos
                              ? usersSummary?.data?.approved_videos
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Rejected submissions
                          </Typography>
                          <Typography variant="caption">
                            {usersSummary?.data?.rejceted_videos
                              ? usersSummary?.data?.rejceted_videos
                              : "-"}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">
                            Duplicated submissions
                          </Typography>
                          <Typography variant="caption">
                            {usersSummary?.data?.duplicate_videos
                              ? usersSummary?.data?.duplicate_videos
                              : "-"}
                          </Typography>
                        </ListItem>
                      </List>
                    </VideosummaryCard>
                  </Box>
                </Stack>
              </Box>
            ) : (
              /* ================================ */
              /* ========= PARTNERS EMPTY ========= */
              <Stack
                alignItems={"center"}
                justifyContent={"center"}
                className={styles.editorNoitem}
              >
                <figure>
                  <img
                    src={assest.partnerAddImg}
                    width={105}
                    height={87}
                    alt="icon"
                  />
                </figure>
                <Typography variant="body1">
                  No editors have been added yet.
                </Typography>
                <Button
                  startIcon={<AddRadiusIcon />}
                  className={styles.addeditorBtn}
                  onClick={() => handleOpenNewEditorModal()}
                >
                  Add a Partner
                </Button>
              </Stack>
              /* ========= PARTNERS EMPTY END ========= */
              /* ================================ */
            )}
            <AddNewEditorModal
              open={openNewEditorModal}
              onClose={handleCloseNewEditorModal}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                flexWrap="wrap"
                className={styles.modalHeading}
              >
                <Typography variant="h3">Add new PARTNER</Typography>
                <Button onClick={handleCloseNewEditorModal}>
                  <img
                    src={assest.crossGray}
                    width={13}
                    height={13}
                    alt="icon"
                  />
                </Button>
              </Stack>
              <Stack className={styles.tabsButtonCenter}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="Personal Details" {...a11yProps(0)} />
                  <Tab label="Submission Page Setup" {...a11yProps(1)} />
                </Tabs>
              </Stack>
              <Box className={styles.innerPanel}>
                <TabPanel value={value} index={0}>
                  <PerfectScrollbar>
                    <Box className={styles.accountFormGroup}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.labelStack}
                      >
                        <Typography variant="caption">Full name</Typography>
                      </Stack>
                      <Box className={styles.gridWrap}>
                        <Grid
                          container
                          rowSpacing={3}
                          columnSpacing={{
                            xs: 1,
                            sm: 2,
                            md: 5.75,
                          }}
                        >
                          <Grid item md={4.02}>
                            <Box className={`${styles.formGroup}`}>
                              <label>First Name</label>
                              <OutlinedInput
                                type="text"
                                placeholder={""}
                                {...register("first_name")}
                              />
                              {errors?.first_name ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.first_name?.message}
                                </span>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Grid>
                          <Grid item md={4.02}>
                            <Box className={`${styles.formGroup}`}>
                              <label>Last name</label>
                              <OutlinedInput
                                type="text"
                                name="last_name"
                                placeholder={""}
                                {...register("last_name")}
                              />
                              {errors?.last_name ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.last_name?.message}
                                </span>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                    <Box className={styles.accountFormGroup}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.labelStack}
                      >
                        <Typography variant="caption">
                          Physical Address
                        </Typography>
                      </Stack>
                      <Box className={styles.gridWrap}>
                        <Box className={styles.forAddress}>
                          <Grid
                            container
                            rowSpacing={3}
                            columnSpacing={{
                              xs: 1,
                              sm: 2,
                              md: 5.75,
                            }}
                          >
                            <Grid item md={6.8}>
                              <Box className={styles.formGroup}>
                                <label>Address</label>
                                <OutlinedInput
                                  type="text"
                                  placeholder={""}
                                  {...register("address")}
                                />
                                {errors?.address ? (
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {errors?.address?.message}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                        <Grid
                          container
                          rowSpacing={3}
                          columnSpacing={{
                            xs: 1,
                            sm: 2,
                            md: 5.75,
                          }}
                        >
                          <Grid item md={3.4}>
                            <Box className={styles.formGroup}>
                              <label>City</label>
                              <OutlinedInput
                                type="text"
                                placeholder={""}
                                {...register("city")}
                              />
                              {errors?.city ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.city?.message}
                                </span>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Grid>
                          <Grid item md={3.4}>
                            <Box className={styles.formGroup}>
                              <label>State</label>
                              <OutlinedInput
                                type="text"
                                placeholder={""}
                                {...register("state")}
                              />
                              {errors?.state ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.state?.message}
                                </span>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Grid>
                          <Grid item md={2.34}>
                            <Box className={styles.formGroup}>
                              <label>Zip Code</label>
                              <OutlinedInput
                                type="text"
                                placeholder={""}
                                {...register("zip_code")}
                              />
                              {errors?.zip_code ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.zip_code?.message}
                                </span>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Grid>
                          <Grid item md={4.02}>
                            <Controller
                              name="country"
                              control={control}
                              render={({
                                field: { onChange, value },
                                fieldState: { invalid },
                              }) => (
                                <Box
                                  className={`${styles.formGroup} ${styles.formGroup200}`}
                                >
                                  <label>Country</label>
                                  <Select
                                    value={Country}
                                    onChange={(event) =>
                                      handleCountryChange(event)
                                    }
                                    displayEmpty
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                  >
                                    <MenuItem value="">Select country</MenuItem>

                                    {countryData.map((Data) => (
                                      <MenuItem value={Data.name}>
                                        {Data.name}({Data.code})
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </Box>
                              )}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                    <Box className={styles.accountFormGroup}>
                      <Stack
                        direction="row"
                        alignItems="center"
                        flexWrap="wrap"
                        className={styles.labelStack}
                      >
                        <Typography variant="caption">Phone Number</Typography>
                      </Stack>
                      <Box className={styles.gridWrap}>
                        <Grid
                          container
                          rowSpacing={3}
                          columnSpacing={{
                            xs: 1,
                            sm: 2,
                            md: 5.75,
                          }}
                        >
                          <Grid item md={4.02}>
                            <Box className={`${styles.formGroup}`}>
                              <OutlinedInput
                                type="phone"
                                placeholder={""}
                                {...register("mobile")}
                              />
                              {errors?.mobile ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "15px",
                                  }}
                                >
                                  {errors?.mobile?.message}
                                </span>
                              ) : (
                                ""
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </PerfectScrollbar>
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <Box className={styles.accountSettingWrapper}>
                    <PerfectScrollbar>
                      <Box className={styles.forProfilePic}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          flexWrap="wrap"
                          className={styles.labelStack}
                        >
                          <Typography variant="caption">
                            Profile Picture
                          </Typography>
                        </Stack>
                        <Stack
                          direction="row"
                          alignItems="center"
                          flexWrap="wrap"
                          className={styles.profileSec}
                        >
                          <Avatar
                            alt="Remy Sharp"
                            src={
                              profile
                                ? URL.createObjectURL(profile)
                                : assest.userPlaceholder
                            }
                            sx={{
                              width: 97,
                              height: 97,
                            }}
                          />
                          <List>
                            <ListItem className={styles.customUploadFile}>
                              <input
                                type="file"
                                id="upload"
                                hidden
                                onChange={uploadImage}
                              />
                              <label htmlFor="upload">Update picture</label>
                            </ListItem>
                            <ListItem>
                              <Button
                                className={styles.removeBtn}
                                onClick={() => setProfile(null)}
                              >
                                remove it
                              </Button>
                            </ListItem>
                          </List>
                        </Stack>
                      </Box>
                      <Box
                        className={`${styles.forEmail} ${styles1.forEmailPartner}`}
                      >
                        <Box className={styles.gridWrap}>
                          <Grid
                            container
                            rowSpacing={3}
                            columnSpacing={{
                              xs: 1,
                              sm: 2,
                              md: 5.75,
                            }}
                          >
                            <Grid item md={6.3}>
                              <Box
                                className={`${styles.formGroup} ${styles1.formGroup}`}
                              >
                                <label>Account Name</label>
                                <OutlinedInput
                                  type="text"
                                  {...register("account_name")}
                                />
                                {errors?.account_name ? (
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {errors?.account_name?.message}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                            <Grid item md={6.3}>
                              <Box
                                className={`${styles.formGroup} ${styles1.formGroup}`}
                              >
                                <label>Submission Page URL</label>
                                <OutlinedInput
                                  type="text"
                                  {...register("submission_link")}
                                />
                                {errors?.submission_link ? (
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {errors?.submission_link?.message}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                            <Grid item md={3.7}>
                              <Box
                                className={`${styles.formGroup} ${styles1.formGroup} ${styles1.revenueformGroup}`}
                              >
                                <label>Revenue Share</label>
                                <OutlinedInput
                                  type="number"
                                  {...register("revenue_share")}
                                />
                                {errors?.revenue_share ? (
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {errors?.revenue_share?.message}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                            <Grid item md={6.3}>
                              <Box
                                className={`${styles.formGroup} ${styles1.formGroup}`}
                              >
                                <label>Email address</label>
                                <OutlinedInput
                                  type="text"
                                  {...register("email")}
                                />
                                {errors?.email ? (
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "15px",
                                    }}
                                  >
                                    {errors?.email?.message}
                                  </span>
                                ) : (
                                  ""
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>

                        <Box className={styles1.compensationBox}>
                          <h5>Compensation Type</h5>
                          <Box
                            className={`${styles1.compensationAmountBoxwrapper} ${styles1.purchase}`}
                          >
                            <Button
                              className={
                                compensationType === "rate_per_video"
                                  ? styles1.activeButton
                                  : styles1.openBtn
                              }
                              onClick={() =>
                                handleCompensationType("rate_per_video")
                              }
                            >
                              Fee Per Purchase{" "}
                              {compensationType === "rate_per_video" && (
                                <img
                                  src={assest.partnerRightIcon}
                                  width={18}
                                  height={18}
                                  alt=""
                                />
                              )}
                            </Button>
                            {compensationType === "rate_per_video" ? (
                              <Box className={styles1.compensationAmountBox}>
                                <p>Please enter Fee amount:</p>
                                <input
                                  type="number"
                                  name="rate_per_video"
                                  onChange={handleFormData}
                                />
                              </Box>
                            ) : (
                              ""
                            )}
                          </Box>
                          <Box
                            className={`${styles1.compensationAmountBoxwrapper} ${styles1.salary}`}
                          >
                            <Button
                              className={
                                compensationType === "flat_rate"
                                  ? styles1.activeButton
                                  : styles1.openBtn
                              }
                              onClick={() =>
                                handleCompensationType("flat_rate")
                              }
                            >
                              Salary{" "}
                              {compensationType === "flat_rate" && (
                                <img
                                  src={assest.partnerRightIcon}
                                  width={18}
                                  height={18}
                                  alt=""
                                />
                              )}
                            </Button>
                            {compensationType === "flat_rate" ? (
                              <Box className={styles1.compensationAmountBox}>
                                <p>Please enter salary amount:</p>
                                <input
                                  type="number"
                                  name="flat_rate"
                                  onChange={handleFormData}
                                />
                              </Box>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </PerfectScrollbar>
                  </Box>
                </TabPanel>
              </Box>
              {value === 0 ? (
                <Box
                  className={styles.nextBtn}
                  onClick={handleSubmit(() => setValue(1))}
                >
                  <Button endIcon={<NextArrow />}>NEXT</Button>
                </Box>
              ) : (
                <Box
                  className={styles.nextBtn}
                  onClick={handleSubmit(handleAddNewMemberForm)}
                >
                  <Button>INVITE NOW</Button>
                </Box>
              )}
            </AddNewEditorModal>

            <Backdrop
              open={snackOpen || openNewEditorModal}
              onClick={handleClose}
              sx={{ zIndex: "111" }}
              className={styles.snackBackDrop}
            >
              <Snackbar
                open={snackOpen}
                autoHideDuration={1000}
                onClose={handleClose}
                message={`Invitation Sent Successfully`}
                ContentProps={{
                  sx: {
                    justifyContent: "center",
                    minWidth: "246px !important",
                    background: "#000",
                    boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                    height: "45px",
                    padding: 0,
                    "& .MuiSnackbarContent-message": {
                      fontWeight: "500",
                      fontSize: "13px",
                    },
                  },
                }}
              />
            </Backdrop>
          </PerfectScrollbar>
        </Box>
      </Box>
    </Wrapper>
  );
};

export default Partner;
